import { Button, ButtonProps, Spin } from "antd";
import { FunctionComponent } from "react";

interface ActionBtnProps extends ButtonProps {
  busy?: boolean;
  busyMessage?: string;
}

const ActionBtn: FunctionComponent<ActionBtnProps> = ({
  busy,
  busyMessage,
  children,
  ...props
}) => {
  const Btn = (
    <Button {...props} disabled={props.disabled || busy}>
      {children}
    </Button>
  );
  if (busy) {
    return <Spin tip={busyMessage}>{Btn}</Spin>;
  }
  return Btn;
};

export default ActionBtn;
